export const getIndustries = (includeBenchmarks: boolean) => {
    let url = `/lf/data/api/v1/industries?page=0&size=100&sort=name,ASC`;

    if (includeBenchmarks) {
        url = `${url}&include=benchmarks`;
    }

    return fetch(url, { method: 'GET' });
};
